<template>
    <div class="redesign-language-switcher" data-testid="language-switcher-container">
        <RedesignBaseSelect
            :value="activeLanguage"
            :multiple="false"
            :filterable="false"
            :disabled="disabled"
            :config="{
                labelKey: 'abbName',
                valueKey: 'locale'
            }"
            data-testid="language-select"
            placeholder=""
            class="language-select"
            @change="onLocaleChange"
        >
            <template #prefix>
                <div
                    class="flex items-center"
                    :class="{'ml-10': $rtl.isRTL}"
                    data-testid="language-current"
                >
                    <img
                        class="w-6 h-4 mx-2 text-sm"
                        :src="activeLanguage.icon"
                        :alt="activeLanguage.name"
                        data-testid="language-icon"
                    >
                    {{ activeLanguage.abbName }}
                </div>
            </template>
            <el-option
                v-for="(language, index) in languageList"
                :key="`${language.locale}-${index}`"
                class="flex items-center justify-between"
                :value="language"
                data-testid="language-option"
            >
                <div class="flex items-center">
                    <img
                        :src="language.icon"
                        :alt="language.name"
                        class="w-6 h-4"
                    >
                    <span class="mx-2 custom-text-color">
                        {{ language.name }}
                    </span>
                </div>
            </el-option>
        </RedesignBaseSelect>
    </div>
</template>

<script setup lang="ts">
import RedesignBaseSelect from '@/components/RedesignBaseComponents/Inputs/RedesignBaseSelect.vue'
import { Option as ElOption } from 'element-ui'
import { activeLanguage, languageList, LanguageMapped } from '@/composables/globalData/useLanguages'

withDefaults(
    defineProps<{
        label?: string
        prefix?: string
        detectCountry?: boolean
        disabled?: boolean
    }>(),
    {
        label: '',
        prefix: '',
        detectCountry: true,
        disabled: false
    }
)

function onLocaleChange (locale: LanguageMapped) {
    const oldLocation = window.location
    const oldDomain = oldLocation.hostname

    window.location.href = oldLocation.href.replace(oldDomain, locale.Domain)
}
</script>

<style lang="scss">
    .redesign-language-switcher {
        @apply max-w-28 min-w-28;
      .language-select {
        .el-select.el-select--small .el-input--small .el-input__inner {
          @apply h-9;
        }
      }
    }
</style>
